<template>
  <div class="client-dashboard d-flex flex-column">
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="client-dashboard-header py-2 px-3">
      <span class="title">Clients</span>
    </div>
    <div class="client-data flex-grow-1 mt-2">
      <div class="list-clients d-flex flex-column w-70">
        <div class="list-title py-3 px-3">List of Clients</div>
        <div class="list-table-section flex-grow-1 py-4 px-3">
          <div class="client-table d-flex flex-column h-100">
            <div class="thead">
              <div class="tr">
                <div class="td clients">
                  Clients
                  <template v-if="sort">
                    <img
                      v-if="sortByValue"
                      class="pointer"
                      @click="(sortByValue = !sortByValue), getClients()"
                      src="../../assets/img/accessconnew/ascSort.svg"
                      alt=""
                    />
                    <img
                      v-if="!sortByValue"
                      class="pointer"
                      @click="(sortByValue = !sortByValue), getClients()"
                      src="../../assets/img/accessconnew/descSort.svg"
                      alt=""
                    />
                  </template>
                  <img
                    v-else
                    @click="(sort = true), (sortByValue = true), getClients()"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt=""
                  />
                </div>
                <div class="td jobs">Jobs</div>
                <div class="td openings">Openings</div>
                <div class="td selected">Selected</div>
                <div class="td action">Action</div>
              </div>
            </div>
            <div v-if="clientList.length != 0" class="tbody">
              <div
                :style="
                  Object.keys(selectedClient).length != 0 &&
                  data.clientLicenseKey == selectedClient.clientLicenseKey &&
                  'background: #E1EEF7'
                "
                class="tr"
                v-for="data in clientList"
                :key="data.clientLicenseKey"
              >
                <div class="td clients client-details d-flex align-items-start">
                  <img
                    src="../../assets/VendorClient/client_icon.svg"
                    alt="Client Icon"
                  />
                  <div class="client-name-date d-flex flex-column">
                    <span class="client-name">{{ data.clientName }}</span>
                    <span class="client-date"
                      >Created on: {{ formattedDate(data.createdAt) }}</span
                    >
                  </div>
                </div>
                <div class="td jobs d-flex align-items-center">
                  <img
                    src="../../assets/VendorClient/job_icon.svg"
                    alt="Job Search"
                  />
                  <span class="job-value">{{ data.jobs }}</span>
                </div>
                <div class="td openings d-flex align-items-center">
                  <img
                    src="../../assets/VendorClient/search_user.svg"
                    alt="User Search"
                  />
                  <span class="openings-value">{{ data.openings }}</span>
                </div>
                <div class="td selected d-flex align-items-center">
                  <img
                    src="../../assets/VendorClient/check_mark.svg"
                    alt="Check Mark"
                  />
                  <span class="openings-value">{{ data.selected }}</span>
                </div>
                <div
                  class="
                    td
                    selected
                    d-flex
                    align-items-center
                    justify-content-between
                  "
                >
                  <img
                    class="pointer"
                    v-if="
                      selectedClient.clientLicenseKey === data.clientLicenseKey
                    "
                    @click.stop="showPreview(data)"
                    src="../../assets/img/newkanban/closeeye.svg"
                    alt="Preview"
                  />
                  <img
                    class="pointer"
                    v-else
                    @click.stop="showPreview(data)"
                    src="../../assets/VendorClient/preview_eye.svg"
                    alt="Preview"
                  />
                  <img
                    class="pointer"
                    @click="gotoJobs(data.vendorID, data.clientName)"
                    src="../../assets/VendorClient/right_arrow.svg"
                    alt="Open"
                  />
                </div>
              </div>
            </div>
            <div v-else class="tbody">
              <div
                v-if="
                  !LoaderStatus && clientList.length === 0 && searchQuery !== ''
                "
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt
                  />
                </div>
                No matching results for&nbsp;
                <strong> "{{ searchQuery }}" </strong>
              </div>

              <div
                v-else-if="
                  !LoaderStatus && clientList.length === 0 && searchQuery === ''
                "
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt
                  />
                </div>
                <div class="search-result-empty-text mt-4">No data found.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="client-full-details px-1 w-30 ml-2">
        <div
          v-if="preview"
          class="
            client-details-header
            py-3
            px-3
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <span>Client Details</span>
          <img
            @click="(preview = false), (selectedClient = {})"
            src="../../assets/VendorClient/x-close.svg"
            alt="Close"
          />
        </div>

        <!-- When a preview is active -->
        <div v-if="preview" class="client-detail-items p-4 d-flex flex-column">
          <div class="client-data-item d-flex flex-column">
            <span class="title">Client Name</span>
            <span class="value">{{ selectedClient.clientName }}</span>
          </div>
          <div class="client-data-item d-flex flex-column">
            <span class="title">Client Address</span>
            <span class="value">{{ selectedClient.clientAddress }}</span>
          </div>
          <div class="client-data-item d-flex flex-column">
            <span class="title">Created On</span>
            <span class="value">{{
              formattedDate(selectedClient.createdAt)
            }}</span>
          </div>
        </div>

        <!-- Preview Placeholder -->
        <div v-else class="client-no-active">
          <div class="no-active-content d-flex flex-column align-items-center">
            <img
              src="../../assets/VendorClient/client_no_active.svg"
              alt="Item Preview Placeholder"
            />
            <span class="text-center"
              >Click on the eye icon to view Client details</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVendorClients } from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { mapGetters } from "vuex";
export default {
  name: "ClientDashboard",
  data() {
    return {
      sort: false,
      sortByValue: false,
      preview: false,
      selectedClient: {},
      clientList: [],
      LoaderStatus: false,
      static_data: [
        {
          id: 1,
          clientName: "CyberMonday Private Limited",
          clientAddress:
            "449, 17th Cross Rd, Sector 4, HSR Layout, Bengaluru, Karnataka 560102",
          createdOn: "20/02/2023",
          jobs: 23,
          openings: 23,
          selected: 19,
        },
        {
          id: 2,
          clientName: "CyberMonday Private Limited",
          clientAddress:
            "449, 17th Cross Rd, Sector 4, HSR Layout, Bengaluru, Karnataka 560102",
          createdOn: "20/02/2023",
          jobs: 23,
          openings: 23,
          selected: 19,
        },
        {
          id: 3,
          clientName: "CyberMonday Private Limited",
          clientAddress:
            "449, 17th Cross Rd, Sector 4, HSR Layout, Bengaluru, Karnataka 560102",
          createdOn: "20/02/2023",
          jobs: 23,
          openings: 23,
          selected: 19,
        },
      ],
    };
  },
  components: {
    Spinner,
  },
  created() {
    this.getClients();
  },
  computed: {
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        this.LoaderStatus = true;
        if (newValue != "Loader") {
          this.getClients();
        }
      }
    },
  },
  methods: {
    showPreview(client) {
      if (!this.preview) {
        this.selectedClient = client;
        this.preview = true;
      } else {
        if (client.clientLicenseKey != this.selectedClient.clientLicenseKey) {
          this.selectedClient = client;
        } else {
          this.selectedClient = {};
          this.preview = false;
        }
      }
    },
    // onScroll(e) {
    //   console.log("yes");
    //   const { target } = e;
    //   if (
    //     Math.ceil(target.scrollTop) >=
    //     target.scrollHeight - target.offsetHeight
    //   ) {
    //     // Check if there is more data to load.
    //     if (this.checkbetween(this.pageEnd, 0, this.total)) {
    //       this.page++;

    //       this.getClients();
    //     }
    //   }
    // },
    formattedDate(date) {
      const dateObj = new Date(date);
      const day = dateObj.getDate().toString().padStart(2, "0");
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const year = dateObj.getFullYear().toString();
      return `${day}-${month}-${year}`;
    },
    gotoJobs(vendorId, client) {
      this.$router.push({
        name: "jobs",
        query: {
          clientName: client,
        },
        params: {
          vendorID: vendorId,
          client: client,
        },
      });
    },
    async getClients() {
      this.LoaderStatus = true;
      let sortType = this.sortByValue ? "+" : "-";
      try {
        let payload = {
          searchQuery: this.searchQuery,
          sort: sortType + "organizationName",
        };
        const res = await getVendorClients(payload);
        if (res.status == 200) {
          this.clientList = res.data.data;
          this.LoaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
.client-dashboard {
  position: relative;
  padding: 15px 20px 0px 77px;
  top: 71px;
  height: calc(100vh - 71px);
  background-color: #e9ecef;
  overflow-y: hidden;
}

.client-dashboard .client-dashboard-header {
  background-color: #f6f9fb;
  border-radius: 6px;
}

.client-dashboard .client-dashboard-header .title {
  color: #20639b;
  font-weight: 500;
  font-size: 20px;
}

.client-dashboard .client-data {
  display: flex;
  align-items: stretch;
  height: 100%;
  margin-bottom: 12px;
  border-radius: 4px;
}

.client-dashboard .client-data .list-clients {
  border-radius: 4px;
  background-color: #fff;
  height: 100%;
  overflow-y: scroll;
}

.client-dashboard .client-data .list-clients .list-title {
  border-bottom: 1px solid #dddddd;
  font-weight: 500;
}

.client-table .thead {
  background-color: #e9f0f5;
}

.client-table .thead .tr {
  display: flex;
  align-items: center;
}

.client-table .thead .td {
  color: #20639b;
  font-size: 14px;
  font-weight: 500;
}

.client-table .thead .td.clients {
  width: 35%;
}

.client-table .thead .td.jobs,
.td.openings,
.td.selected,
.td.action {
  width: 16.25%;
}

.client-table {
  width: 100%;
}

.client-table .td {
  padding: 10px 14px;
  white-space: wrap;
}

.client-table .tbody {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: calc(100vh - 310px);
  padding-bottom: 50px;
  overflow-y: auto;
}

.client-table .tbody .tr {
  box-shadow: 0 5px 5px #e1e1e1;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #eeeeee;
}

.client-table .tbody .td.clients {
  width: 35%;
}

.client-table .tbody .td.jobs,
.td.openings,
.td.selected,
.td.action {
  width: 16.25%;
}

.client-table .tbody .td.jobs,
.tbody .td.openings,
.tbody .td.selected,
.tbody .td.action {
  gap: 6px;
}

.client-table .tbody .tr .td.client-details {
  gap: 8px;
}

.client-table .tbody .tr .td.client-details .client-name-date {
  gap: 6px;
}

.client-table .tbody .tr .td.client-details .client-name {
  font-size: 15px;
  font-weight: 500;
}

.client-table .tbody .tr .td.client-details .client-date {
  font-size: 12px;
  font-weight: 400;
  color: #888888;
}

.client-full-details {
  background-color: #fff;
  border-radius: 4px;
  background-color: #fff;
}

.client-full-details .client-details-header {
  border-bottom: 1px solid #dddddd;
  font-weight: 500;
}

.client-full-details .client-detail-items {
  gap: 32px;
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  padding-bottom: 50px;
}

.client-full-details .client-detail-items .client-data-item .title {
  font-size: 13px;
  font-weight: 500;
}

.client-full-details .client-detail-items .client-data-item .value {
  font-size: 14px;
  font-weight: 600;
}

.client-full-details .client-no-active {
  display: grid;
  place-items: center;
  height: calc(100vh - 220px);
}

.client-full-details .client-no-active .no-active-content {
  width: 50%;
}

.client-full-details .client-no-active .no-active-content img {
  width: 100%;
}

.client-full-details .client-no-active .no-active-content span {
  font-size: 14px;
}

@media screen and (max-width: 1024px) {
  .client-dashboard {
    padding: 15px 20px 0px 20px;
  }
}
</style>
